/** field labels (Customer info) */
export const PHONE_ME_TITLE = 'Please tick the box if you would like to receive information about our products and, or any special offers by telephone, text message, and, or by recorded call, including from our specially selected third parties.';
export const OFFER_ME_TITLE = 'Please tick the box if you would like to receive information about our products and, or any special offers by email and social advertisements, including from our specially selected third parties.';

/** error messages (Customer info) */
export const TITLE_REQUIRED_ERROR_MESSAGE = 'Please provide your title';
export const FIRST_NAME_REQUIRED_ERROR_MESSAGE = 'Please provide your first name';
export const SURNAME_REQUIRED_ERROR_MESSAGE = 'Please provide your last name';
export const PHONE_REQUIRED_ERROR_MESSAGE = 'Please provide a contact telephone number';
export const PRIVACY_POLICY_REQUIRED_ERROR_MESSAGE = 'Please confirm that you have read our Privacy Policy.';
export const TERM_AND_CONDITIONS_REQUIRED_ERROR_MESSAGE = 'Please confirm that you have read our Terms and Conditions.';
export const phoneMinLengthErrorMessage = (min: number) => `Telephone number should be at least ${min} digits`;
export const PHONE_VALIDATION_ERROR_MESSAGE = 'Please provide a valid telephone number';
export const NO_SELECTED_ADDRESS_ERROR_MESSAGE = 'Please either select an address from dropdown or click the link to enter the address manually';

export const ADDRESS_REQUIRED_ERROR_MESSAGE = 'Please either select an address from dropdown or click the link to enter the address manually';
export const POSTCODE_INVALID_ERROR_MESSAGE = 'The postcode you entered is not valid';
export const POSTCODE_IS_EIRE_FOR_IFC_ERROR_MESSAGE = 'Sorry, 0% Interest Free Credit is not currently available for customers in Eire';

/** error messages (LoginForm and RegisterForm) */
export const EMAIL_REQUIRED_ERROR_MESSAGE = 'Please enter an email address';
export const EMAIL_NOT_VALID_ERROR_MESSAGE = 'Please enter a valid email address';
export const EMAIL_NOT_MATCH_ERROR_MESSAGE = 'Email addresses must match';
export const CONFIRM_EMAIL_ERROR_MESSAGE = 'Please confirm your email address';
export const WRONG_PASSWORD_WARNING_LINES = [
    'Sorry, either the email or password were incorrect.',
    'Please check and try again.'
];
export const ACCOUNT_NOT_ACTIVATED_WARNING_LINES = [
    'Account for the entered email address exists, but it is not activated.',
    'To activate it, please search in your email box for an email from us and follow the provided instructions.'
];
export const INVALID_LOGIN_DETAILS_MESSAGE = 'An incorrect email or password has been entered. Please try again';
export const FORGOT_PASSWORD_HINT = 'Forgot password?';
export const CREATE_ACCOUNT_WARNING = 'Please create an account';
export const ACCOUNT_DOESNT_EXIST_WARNING = 'The email you\'ve entered doesn\'t match any account.';
export const ACCOUNT_EXISTS_WARNING = {
    prefix: 'This email can\'t be used to register an account.',
    linkText: 'Please log in',
    postfix: ' or try another email address.'
};

/** field labels (Address) */
export const BILLING_ADDRESS_SAME_AS_DELIVERY = 'Billing address same as delivery address';

export const BILLING_ADDRESS_SEARCH_EDITOR_ID = 'BILLING_ADDRESS_SEARCH_EDITOR_ID';

